var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcCloseInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1698 9.99528L14.7485 6.42469C15.0748 6.09833 15.0748 5.56919 14.7485 5.24282C14.4221 4.91646 13.893 4.91646 13.5667 5.24282L9.99634 8.82173L6.42601 5.24282C6.09967 4.91646 5.57057 4.91646 5.24422 5.24282C4.91788 5.56919 4.91788 6.09833 5.24422 6.42469L8.82288 9.99528L5.24422 13.5659C5.08667 13.7221 4.99805 13.9349 4.99805 14.1568C4.99805 14.3787 5.08667 14.5915 5.24422 14.7477C5.40049 14.9053 5.61321 14.9939 5.83512 14.9939C6.05703 14.9939 6.26974 14.9053 6.42601 14.7477L9.99634 11.1688L13.5667 14.7477C13.7229 14.9053 13.9357 14.9939 14.1576 14.9939C14.3795 14.9939 14.5922 14.9053 14.7485 14.7477C14.906 14.5915 14.9946 14.3787 14.9946 14.1568C14.9946 13.9349 14.906 13.7221 14.7485 13.5659L11.1698 9.99528Z",
    fill: "#006C9C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcCloseInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_close_info.f381737564a886fbfd0ece0696391afe.svg";